// src/components/questionnaire/QuestionnaireChooser.tsx
/* ------------------------------------------------------------------ */
/* QuestionnaireChooser – lists available questionnaire “pods”         */
/* ------------------------------------------------------------------ */
/**
 * Grid of assessment tiles → routes user to `/questionnaires/:slug`.
 *
 * **Data source**
 *   – `QUESTIONNAIRES` constant in `utils/constants.js`
 *     (Add / remove items there; this component then updates automatically.)
 *
 * Wrapped in **`React.memo`** because the content is static; it only re-renders
 * if the `QUESTIONNAIRES` reference itself changes.
 *
 * @returns {JSX.Element}
 */

import React, { memo } from "react";
import { Link } from "react-router-dom";
import { QUESTIONNAIRES } from "../../utils/constants";

export const QuestionnaireChooser = memo(() => (
  <div className="w-full flex flex-col justify-between md:justify-start items-center p-8 gap-6 max-w-lg">
    <h1 className="subtitle-text">Select a Questionnaire</h1>

    <div className="w-full grid grid-cols-2 gap-4">
      {QUESTIONNAIRES.map(({ slug, label }) => (
        <Link
          key={slug}
          to={`/questionnaires/${slug}`}
          className="primary-button w-full text-center"
        >
          {label}
        </Link>
      ))}
    </div>
  </div>
));
